import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "@ts-digital/vrc";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import {
  modifyDeadline,
  splitDeadlines
} from "../../store/actions/deadlines/detail";
import DeadlinesSingleRowEdit from "./deadlinesSingleRowEdit";
import { orderBySingleField } from "../../libs/arrayUtils";

const DeadlinesEdit = props => {
  const {
    closeModalFunc,    
    modalVisibled,
    myType,
    getDetailDetailsById
  } = props;
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();
  /** Comanda il tasto save finchè i dati non tornano il tasto è disabilitato */
  const [disableSave, setDisableSave] = useState(true);
  /** modalità edit che va a chiamare l'api di edit */
  const [editMode, setEditMode] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  /** modalità split che va a chiamare l'api di split. editMode e splitMode sono mutuamente esclusivi */
  const [splitMode, setSplitMode] = useState(false);
  /** Compilo la lista quando effettuo una modifica/aggiunta in modo da inviarla al BE */
  const [newList, setNewList] = useState([]);

  /** REDUX STATE */
  const date = useSelector(state => state.deadlinesDetail.subjective.date);
  const idDeadline = useSelector(state => state.deadlinesDetail.subjective.id);
  const isLoadingModified = useSelector(state => state.deadlinesDetail.isLoadingModified);
  const isModifiedDeadline = useSelector(state => state.deadlinesDetail.isModifiedDedline);
  const totalAmount = useSelector(state => state.deadlinesDetail.subjective.totalAmount);
  /** Devo mantenere il segno */
  const sign = useSelector(state =>
    Math.sign(state.deadlinesDetail.subjective.totalAmount));

  const paymentModeId = useSelector(state => state.deadlinesDetail.subjective.payment.mode.id);
  const suspended = useSelector(state => state.deadlinesDetail.subjective.payment.status === "suspended");

  const updateFirstRowValue = () => {

    if (newList.length > 1) return;
    const startedList = [];
    startedList.push({
      date: typeof date === "string" ? new Date(date) : date,
      amount: totalAmount,
      paymentModeId: paymentModeId,
      suspended: suspended
    });

    setNewList(startedList);
  };

  useEffect(() => {
    updateFirstRowValue();
  }, []);

  useEffect(() => {
    updateFirstRowValue();
  }, [totalAmount, date,paymentModeId, suspended ]);

  useEffect(() => {
    if (!isModifiedDeadline) return;
    closeModalFunc();

    if (editMode) {
      //   dispatch(getDeadlineDetail( idDeadline));
      if (idDeadline === location?.pathname?.split("scadenza/")[1]){
        getDetailDetailsById(idDeadline);
      }

    } else {
      // per problemi applicativi una volta splittato torno alla lista scadenze
      if (myType === "STUDIO"){
        navigate("/scadenze");
      } else {
        navigate({
          pathname: "/scadenzecliente",
          state: {
            viewType: "calendar"
          }
        });    
      }           
    }
  });

  useEffect(() => {
    setSplitMode(!editMode);
  }, [editMode]);

  useEffect(() => {
    // serve a t0 quando mi arriva una scadenza priva di metodo pagamento
    const errorEmpty = document.getElementsByClassName("errorEmpty") || [];
    if (errorEmpty.length > 0) {
      setErrorMessage("Compilare tutti i campi obbligatori");
    }
  });

  useEffect(() => {
    setTimeout(() => {
      if (newList.length === 0) return;
      const sumTotal = sumTotalAmountArr(newList, 0);
      const findedZeros = newList.filter(el => !el.amount || el.amount === 0);

      if (Math.abs(sumTotal) !== Math.abs(totalAmount)) {
        setErrorMessage("Il totale scadenza originaria deve coincidere con le modifiche effettuate");
      } else if (findedZeros.length > 0) {
        setErrorMessage("Non può essere creata una scadenza con importo 0");
      } else {
        setErrorMessage(null);
      }
    }, 300);
  }, [newList]);

  useEffect(() => {
    // Disabilito il save se ho un qualsiasi errore
    if (!errorMessage) setDisableSave(false);
    else setDisableSave(true);
  }, [errorMessage]);

  const sumTotalAmountArr = (cloneList, totalDefault) => {
    let total = 0;
    if (cloneList.length > 1) {
      total = cloneList.reduce((a, b) => {
        return (typeof a === "object" ? a.amount : a) + b.amount;
      });
    } else if (cloneList.length === 1) {
      total = cloneList[0].amount;
    } else {
      total = totalDefault;
    }
    return total;
  };

  const changeList = () => {
    const cloneList = [...newList];
    // disableSave && setDisableSave(false);
    const subtotal = sumTotalAmountArr(cloneList, totalAmount);
    createNewRow(cloneList, subtotal);
    editMode && setEditMode(false);

    setNewList(cloneList);
  };

  const createNewRow = (initialArray, subtotal) => {
    /** Se sto passando da edit mode a split allora subtotal lo valorizzo con il valore appena modificato */
    const partial =
      subtotal || subtotal === 0
        ? subtotal
        : initialArray.reduce((a, b) => {
          return (typeof a === "object" ? a.amount : a) + b.amount;
        });
    initialArray.push({
      date: new Date(),
      amount:
        Math.abs(totalAmount) <= Math.abs(partial)
          ? 0
          : sign * (Math.abs(totalAmount) - Math.abs(partial)),
      paymentModeId: paymentModeId,
      suspended: false
    });

    return initialArray;
  };

  const changeSpecificValue = (
    indexToChange, key, value
  ) => {
    let cloneList = [...newList];
    if (cloneList.length === 0) return;

    // Devo mantenere il segno pena cambiare una scadenza da pagare in una da ricevere
    cloneList[indexToChange][key] =
      key === "amount" && value ? sign * value : value;

    key === "amount" && setEditMode(false);

    setNewList(cloneList);
  };

  const removeRow = index => {
    const cloneList = [...newList];
    if (editMode) return;
    cloneList.splice(index, 1);

    setNewList(cloneList);
    if (cloneList.length <= 1) {
      setEditMode(true);
      setDisableSave(true);
    }
  };

  const resetRows = () => {

    setNewList([]);
    setEditMode(true);
    setErrorMessage(null);
    closeModalFunc();
    document.getElementsByTagName("body")[0].style.overflow = "auto";
  };

  const getCloserDeadline = res => {
    return new Promise((resolve, reject) => {
      const deadlinesList = res?.created;
      const orderedDeadlinesList = orderBySingleField(deadlinesList, "date");
      const newDeadline = orderedDeadlinesList[0];
      const newDeadlineId = newDeadline?.id;

      resolve(newDeadlineId);
    });
  };

  const redirectToNewDeadline = res => {

    getCloserDeadline(res).then(id => {

      navigate({
        pathname: `/scadenza/${id}`
      });
    });
    // window.location.reload();
  };

  const redirectToSameDeadline = deadlineId => {
    setTimeout(() => {
      navigate({
        pathname: `/scadenza/${deadlineId}`
      });
    }, 300);

    // window.location.reload();
  };

  const saveChanges = () => {
    if (errorMessage) return;

    if (editMode) {
      /** sto modificando solo modalità di pagamento o data */

      // mi serve clonare l'oggetto per poi cancellare solo sul clone la propery amount
      const cloneList = JSON.parse(JSON.stringify(newList));
      // rimuovo amount dall'oggetto da modificare
      delete cloneList[0].amount;

      dispatch(modifyDeadline(cloneList[0])).then(redirectToSameDeadline(idDeadline));
    } else if (splitMode) {
      /** sto splittando una scadenza */
      // Per passare i dati all'api devo sostituire il valore booleano di suspeded con paymentStatus che è una stringa

      const cloneListForApi = JSON.parse(JSON.stringify(newList));
      cloneListForApi.forEach(element => {
        element.paymentStatus = element.suspended === true ? "suspended" : null;
        delete element.suspended;
      });
      dispatch(splitDeadlines(idDeadline,
        cloneListForApi)).then(res => redirectToNewDeadline(res));
    }
    setEditMode(true);
  };

  return (
    modalVisibled && (
      <Modal
        visible={modalVisibled}
        title={<FormattedMessage id="documents.detail.modifyDeadlines" />}
        onClose={e => {
          resetRows();
        }}
        type="primary"
        outsideClosable={false}
        footer={
          <div style={{ padding: "8px 0", width: "100%", textAlign: "right" }}>
            <Button
              kind="secondary"
              colorScheme={"ghost"}
              style={{ marginRight: "16px" }}
              className="buttonNav"
              onClick={resetRows}
            >
              <FormattedMessage id="generic.cancel" />
            </Button>

            <Tooltip
              color={"rgb(0, 80, 117)"}
              placement="top"
              title={errorMessage}
              style={{ zIndex: 9999 }}
              getPopupContainer={trigger => trigger.parentNode}
            >
              <div style={{ display: "inline-block" }}>
                <Button
                  disabled={disableSave}
                  className="buttonNav"
                  onClick={e => !isLoadingModified && saveChanges()}
                >
                  {isLoadingModified ? (
                    <FontAwesomeIcon
                      icon={["far", "circle-notch"]}
                      spin
                      style={{ color: "#FFF", fontSize: "21px" }}
                    />
                  ) : (
                    <FormattedMessage id="generic.save" />
                  )}
                </Button>
              </div>
            </Tooltip>
          </div>
        }
      >
        <div style={{ maxWidth: "800px", width: "80vw", minHeight:"370px" }}>
          <section style={{minHeight: "150px"}}>
            <header className="tableFluid">
              <div className="colFluid" style={{ flex: "0.5 0" }}></div>
              <div className="colFluid">
                Importo (€)
              </div>
              <div className="colFluid">Data</div>
              <div
                className="colFluid"
                style={{ flex: "0 0 auto", width: "210px" }}
              >
                Modalità di pagamento
              </div>
              <div
                className="colFluid"
                style={{
                  flex: "0 0 auto",
                  width: myType && myType !== "STUDIO" ? "170px" : "60px"
                }}
              ></div>
            </header>
            {/** SCENARI
             * newList vuoto: mostro un'unica riga con i dati scadenza
             * newList popolata(quindi ho modificato cose): scorro la lista e mostro le varie righe
             */}
            {newList.length === 0 ? (
              <DeadlinesSingleRowEdit
                addEmptyRow={changeList}
                blockTrash={true}
                changeSpecificValue={changeSpecificValue}
                currentIndex={0}
                dataSource={{
                  date: date,
                  amount: totalAmount,
                  paymentModeId: paymentModeId,
                  suspended: suspended
                }}
                rowDescription="Scadenza"
              />
            ) : (
              newList.map((el, index) => {
                return (
                  <DeadlinesSingleRowEdit
                    addEmptyRow={changeList}
                    dataSource={{
                      date: el.date || new Date(),
                      amount: el.amount /* || (el.amount === 0 && 0) || null*/,
                      paymentModeId: el.paymentModeId || null,
                      suspended: el.suspended
                    }}
                    changeSpecificValue={changeSpecificValue}
                    currentIndex={index}
                    key={"singleRow_" + index}
                    removeRow={removeRow}
                    rowDescription="Scadenza"
                  />
                );
              })
            )}
            {/** Mostro il totale solo se sono in caso splittaggio = editMode == false */}
            {!editMode && (
              <DeadlinesSingleRowEdit
                rowDescription="Totale"
                starterImport={totalAmount}
              />
            )}
          </section>
        </div>
      </Modal>
    )
  );
};

export default DeadlinesEdit;
